import styled from 'styled-components';

const Input = styled.input`
  height: 40px;
  margin: 10px 0px;
  padding: 7px;
`;

export default Input;
